module.exports = __webpack_public_path__ + "static/media/IMG_2418.00f1520c.JPG";